/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAbsencesCalendarUserDto } from '../models/work-absences-calendar-user-dto';
import { WorkAddRoletypeDto } from '../models/work-add-roletype-dto';
import { WorkCreateUserDto } from '../models/work-create-user-dto';
import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkLohnlaufAnniversaryDto } from '../models/work-lohnlauf-anniversary-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkRemoveRoletypeDto } from '../models/work-remove-roletype-dto';
import { WorkRoletype } from '../models/work-roletype';
import { WorkSetAnniversaryProcessedDto } from '../models/work-set-anniversary-processed-dto';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkTag } from '../models/work-tag';
import { WorkUpdateUserDto } from '../models/work-update-user-dto';
import { WorkUserStatsDto } from '../models/work-user-stats-dto';
import { WorkUserV2 } from '../models/work-user-v-2';
import { WorkUsersOverviewDto } from '../models/work-users-overview-dto';

@Injectable({ providedIn: 'root' })
export class WorkUsersV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `usersV2ControllerGetAbsencesCalendar()` */
  static readonly UsersV2ControllerGetAbsencesCalendarPath = '/v2/users/absences-calendar';

  /**
   * Required permissions: montageplan:read, montageplan:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersV2ControllerGetAbsencesCalendar()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV2ControllerGetAbsencesCalendar$Response(
    params: {
      dateFrom: string;
      dateTo: string;
      businessunitId?: string;
      businessdivisionId?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkAbsencesCalendarUserDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUsersV2Service.UsersV2ControllerGetAbsencesCalendarPath, 'get');
    if (params) {
      rb.query('dateFrom', params.dateFrom, {});
      rb.query('dateTo', params.dateTo, {});
      rb.query('businessunitId', params.businessunitId, {});
      rb.query('businessdivisionId', params.businessdivisionId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkAbsencesCalendarUserDto>>;
      })
    );
  }

  /**
   * Required permissions: montageplan:read, montageplan:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersV2ControllerGetAbsencesCalendar$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV2ControllerGetAbsencesCalendar(
    params: {
      dateFrom: string;
      dateTo: string;
      businessunitId?: string;
      businessdivisionId?: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkAbsencesCalendarUserDto>> {
    return this.usersV2ControllerGetAbsencesCalendar$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkAbsencesCalendarUserDto>>): Array<WorkAbsencesCalendarUserDto> => r.body)
    );
  }

  /** Path part for operation `usersV2ControllerGetAllDropdownOptions()` */
  static readonly UsersV2ControllerGetAllDropdownOptionsPath = '/v2/users/dropdown-options';

  /**
   * Required permissions: users:read, users:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersV2ControllerGetAllDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV2ControllerGetAllDropdownOptions$Response(
    params: {
      roles: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUsersV2Service.UsersV2ControllerGetAllDropdownOptionsPath, 'get');
    if (params) {
      rb.query('roles', params.roles, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: users:read, users:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersV2ControllerGetAllDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV2ControllerGetAllDropdownOptions(
    params: {
      roles: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.usersV2ControllerGetAllDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `usersV2ControllerGetAll()` */
  static readonly UsersV2ControllerGetAllPath = '/v2/users/getAll';

  /**
   * Required permissions: users:read, users:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersV2ControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV2ControllerGetAll$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkUserV2>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUsersV2Service.UsersV2ControllerGetAllPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkUserV2>>;
      })
    );
  }

  /**
   * Required permissions: users:read, users:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersV2ControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV2ControllerGetAll(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkUserV2>> {
    return this.usersV2ControllerGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkUserV2>>): Array<WorkUserV2> => r.body)
    );
  }

  /** Path part for operation `usersV2ControllerGetAllCurrentlyEmployedUsersCsv()` */
  static readonly UsersV2ControllerGetAllCurrentlyEmployedUsersCsvPath = '/v2/users/getAllCurrentlyEmployedUsersCsv';

  /**
   * Required permissions: users:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersV2ControllerGetAllCurrentlyEmployedUsersCsv()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV2ControllerGetAllCurrentlyEmployedUsersCsv$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUsersV2Service.UsersV2ControllerGetAllCurrentlyEmployedUsersCsvPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: users:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersV2ControllerGetAllCurrentlyEmployedUsersCsv$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV2ControllerGetAllCurrentlyEmployedUsersCsv(
    params?: {
    },
    context?: HttpContext
  ): Observable<void> {
    return this.usersV2ControllerGetAllCurrentlyEmployedUsersCsv$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `usersV2ControllerGetBirthdays()` */
  static readonly UsersV2ControllerGetBirthdaysPath = '/v2/users/birthdays';

  /**
   * Required permissions: users:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersV2ControllerGetBirthdays()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV2ControllerGetBirthdays$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkUserV2>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUsersV2Service.UsersV2ControllerGetBirthdaysPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkUserV2>>;
      })
    );
  }

  /**
   * Required permissions: users:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersV2ControllerGetBirthdays$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV2ControllerGetBirthdays(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkUserV2>> {
    return this.usersV2ControllerGetBirthdays$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkUserV2>>): Array<WorkUserV2> => r.body)
    );
  }

  /** Path part for operation `usersV2ControllerGetUserStatistics()` */
  static readonly UsersV2ControllerGetUserStatisticsPath = '/v2/users/userStatistics';

  /**
   * Required permissions: users:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersV2ControllerGetUserStatistics()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV2ControllerGetUserStatistics$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkUserStatsDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUsersV2Service.UsersV2ControllerGetUserStatisticsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkUserStatsDto>;
      })
    );
  }

  /**
   * Required permissions: users:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersV2ControllerGetUserStatistics$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV2ControllerGetUserStatistics(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkUserStatsDto> {
    return this.usersV2ControllerGetUserStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkUserStatsDto>): WorkUserStatsDto => r.body)
    );
  }

  /** Path part for operation `usersV2ControllerGetOverview()` */
  static readonly UsersV2ControllerGetOverviewPath = '/v2/users/overview';

  /**
   * Required permissions: users:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersV2ControllerGetOverview()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV2ControllerGetOverview$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkUsersOverviewDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUsersV2Service.UsersV2ControllerGetOverviewPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkUsersOverviewDto>;
      })
    );
  }

  /**
   * Required permissions: users:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersV2ControllerGetOverview$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV2ControllerGetOverview(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkUsersOverviewDto> {
    return this.usersV2ControllerGetOverview$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkUsersOverviewDto>): WorkUsersOverviewDto => r.body)
    );
  }

  /** Path part for operation `usersV2ControllerGetAnniversariesForMonth()` */
  static readonly UsersV2ControllerGetAnniversariesForMonthPath = '/v2/users/anniversaries/{month}';

  /**
   * Required permissions: users:admin, reports:lohnlauf
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersV2ControllerGetAnniversariesForMonth()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV2ControllerGetAnniversariesForMonth$Response(
    params: {
      month: number;

    /**
     * Jahr des Jubiläums, Standard: laufendes Jahr
     */
      year?: number;

    /**
     * Nur runde Jubiläen (5, 10, 15, 20, 25 Jahre)
     */
      onlyMilestones?: boolean;

    /**
     * Nur Mitarbeitende, die am Jubiläum in Festanstellung sind
     */
      onlyFestanstellung?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkLohnlaufAnniversaryDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUsersV2Service.UsersV2ControllerGetAnniversariesForMonthPath, 'get');
    if (params) {
      rb.path('month', params.month, {});
      rb.query('year', params.year, {});
      rb.query('onlyMilestones', params.onlyMilestones, {});
      rb.query('onlyFestanstellung', params.onlyFestanstellung, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkLohnlaufAnniversaryDto>>;
      })
    );
  }

  /**
   * Required permissions: users:admin, reports:lohnlauf
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersV2ControllerGetAnniversariesForMonth$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV2ControllerGetAnniversariesForMonth(
    params: {
      month: number;

    /**
     * Jahr des Jubiläums, Standard: laufendes Jahr
     */
      year?: number;

    /**
     * Nur runde Jubiläen (5, 10, 15, 20, 25 Jahre)
     */
      onlyMilestones?: boolean;

    /**
     * Nur Mitarbeitende, die am Jubiläum in Festanstellung sind
     */
      onlyFestanstellung?: boolean;
    },
    context?: HttpContext
  ): Observable<Array<WorkLohnlaufAnniversaryDto>> {
    return this.usersV2ControllerGetAnniversariesForMonth$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkLohnlaufAnniversaryDto>>): Array<WorkLohnlaufAnniversaryDto> => r.body)
    );
  }

  /** Path part for operation `usersV2ControllerSetAnniversaryProcessed()` */
  static readonly UsersV2ControllerSetAnniversaryProcessedPath = '/v2/users/anniversaries/processed';

  /**
   * Required permissions: users:admin, reports:lohnlauf
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersV2ControllerSetAnniversaryProcessed()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersV2ControllerSetAnniversaryProcessed$Response(
    params: {
      body: WorkSetAnniversaryProcessedDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUsersV2Service.UsersV2ControllerSetAnniversaryProcessedPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: users:admin, reports:lohnlauf
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersV2ControllerSetAnniversaryProcessed$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersV2ControllerSetAnniversaryProcessed(
    params: {
      body: WorkSetAnniversaryProcessedDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.usersV2ControllerSetAnniversaryProcessed$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `usersV2ControllerFindAllPaginated()` */
  static readonly UsersV2ControllerFindAllPaginatedPath = '/v2/users';

  /**
   * Required permissions: users:read, users:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV2ControllerFindAllPaginated$Response(
    params?: {
      onlyTeamMembers?: boolean;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by businessunitId query param.
     *           <p>
     *              <b>Format: </b> filter.businessunitId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.businessunitId=$not:$like:John Doe&filter.businessunitId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.businessunitId'?: Array<string>;

    /**
     * Filter by businessdivisionId query param.
     *           <p>
     *              <b>Format: </b> filter.businessdivisionId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.businessdivisionId=$not:$like:John Doe&filter.businessdivisionId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.businessdivisionId'?: Array<string>;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by supervisorId query param.
     *           <p>
     *              <b>Format: </b> filter.supervisorId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.supervisorId=$not:$like:John Doe&filter.supervisorId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.supervisorId'?: Array<string>;

    /**
     * Filter by id query param.
     *           <p>
     *              <b>Format: </b> filter.id={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.id=$not:$like:John Doe&filter.id=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.id'?: Array<string>;

    /**
     * Filter by employmentType query param.
     *           <p>
     *              <b>Format: </b> filter.employmentType={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.employmentType=$not:$like:John Doe&filter.employmentType=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.employmentType'?: Array<string>;

    /**
     * Filter by useremployments.type query param.
     *           <p>
     *              <b>Format: </b> filter.useremployments.type={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.useremployments.type=$not:$like:John Doe&filter.useremployments.type=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.useremployments.type'?: Array<string>;

    /**
     * Filter by useremployments.validFrom query param.
     *           <p>
     *              <b>Format: </b> filter.useremployments.validFrom={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.useremployments.validFrom=$not:$like:John Doe&filter.useremployments.validFrom=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$lte</li>
     * <li>$gte</li>
     * <li>$btw</li></ul>
     */
      'filter.useremployments.validFrom'?: Array<string>;

    /**
     * Filter by useremployments.validTo query param.
     *           <p>
     *              <b>Format: </b> filter.useremployments.validTo={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.useremployments.validTo=$not:$like:John Doe&filter.useremployments.validTo=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$lte</li>
     * <li>$gte</li>
     * <li>$btw</li></ul>
     */
      'filter.useremployments.validTo'?: Array<string>;

    /**
     * Filter by entrydate query param.
     *           <p>
     *              <b>Format: </b> filter.entrydate={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.entrydate=$not:$like:John Doe&filter.entrydate=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$lte</li>
     * <li>$gte</li>
     * <li>$btw</li>
     * <li>$null</li></ul>
     */
      'filter.entrydate'?: Array<string>;

    /**
     * Filter by exitdate query param.
     *           <p>
     *              <b>Format: </b> filter.exitdate={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.exitdate=$not:$like:John Doe&filter.exitdate=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$lte</li>
     * <li>$gte</li>
     * <li>$btw</li>
     * <li>$null</li></ul>
     */
      'filter.exitdate'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> lastName:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>lastName</li>
     * <li>birthdate</li>
     * <li>entrydate</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'lastName:ASC' | 'lastName:DESC' | 'birthdate:ASC' | 'birthdate:DESC' | 'entrydate:ASC' | 'entrydate:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> searchableFullname
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>searchableFullname</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkUserV2>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'businessunitId'?: (string | Array<string>);
'businessdivisionId'?: (string | Array<string>);
'active'?: (string | Array<string>);
'supervisorId'?: (string | Array<string>);
'id'?: (string | Array<string>);
'employmentType'?: (string | Array<string>);
'useremployments.type'?: (string | Array<string>);
'useremployments.validFrom'?: (string | Array<string>);
'useremployments.validTo'?: (string | Array<string>);
'entrydate'?: (string | Array<string>);
'exitdate'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUsersV2Service.UsersV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('onlyTeamMembers', params.onlyTeamMembers, {});
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.businessunitId', params['filter.businessunitId'], {});
      rb.query('filter.businessdivisionId', params['filter.businessdivisionId'], {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('filter.supervisorId', params['filter.supervisorId'], {});
      rb.query('filter.id', params['filter.id'], {});
      rb.query('filter.employmentType', params['filter.employmentType'], {});
      rb.query('filter.useremployments.type', params['filter.useremployments.type'], {});
      rb.query('filter.useremployments.validFrom', params['filter.useremployments.validFrom'], {});
      rb.query('filter.useremployments.validTo', params['filter.useremployments.validTo'], {});
      rb.query('filter.entrydate', params['filter.entrydate'], {});
      rb.query('filter.exitdate', params['filter.exitdate'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkUserV2>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'businessunitId'?: (string | Array<string>);
        'businessdivisionId'?: (string | Array<string>);
        'active'?: (string | Array<string>);
        'supervisorId'?: (string | Array<string>);
        'id'?: (string | Array<string>);
        'employmentType'?: (string | Array<string>);
        'useremployments.type'?: (string | Array<string>);
        'useremployments.validFrom'?: (string | Array<string>);
        'useremployments.validTo'?: (string | Array<string>);
        'entrydate'?: (string | Array<string>);
        'exitdate'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: users:read, users:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV2ControllerFindAllPaginated(
    params?: {
      onlyTeamMembers?: boolean;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by businessunitId query param.
     *           <p>
     *              <b>Format: </b> filter.businessunitId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.businessunitId=$not:$like:John Doe&filter.businessunitId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.businessunitId'?: Array<string>;

    /**
     * Filter by businessdivisionId query param.
     *           <p>
     *              <b>Format: </b> filter.businessdivisionId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.businessdivisionId=$not:$like:John Doe&filter.businessdivisionId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.businessdivisionId'?: Array<string>;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by supervisorId query param.
     *           <p>
     *              <b>Format: </b> filter.supervisorId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.supervisorId=$not:$like:John Doe&filter.supervisorId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.supervisorId'?: Array<string>;

    /**
     * Filter by id query param.
     *           <p>
     *              <b>Format: </b> filter.id={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.id=$not:$like:John Doe&filter.id=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.id'?: Array<string>;

    /**
     * Filter by employmentType query param.
     *           <p>
     *              <b>Format: </b> filter.employmentType={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.employmentType=$not:$like:John Doe&filter.employmentType=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.employmentType'?: Array<string>;

    /**
     * Filter by useremployments.type query param.
     *           <p>
     *              <b>Format: </b> filter.useremployments.type={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.useremployments.type=$not:$like:John Doe&filter.useremployments.type=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.useremployments.type'?: Array<string>;

    /**
     * Filter by useremployments.validFrom query param.
     *           <p>
     *              <b>Format: </b> filter.useremployments.validFrom={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.useremployments.validFrom=$not:$like:John Doe&filter.useremployments.validFrom=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$lte</li>
     * <li>$gte</li>
     * <li>$btw</li></ul>
     */
      'filter.useremployments.validFrom'?: Array<string>;

    /**
     * Filter by useremployments.validTo query param.
     *           <p>
     *              <b>Format: </b> filter.useremployments.validTo={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.useremployments.validTo=$not:$like:John Doe&filter.useremployments.validTo=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$lte</li>
     * <li>$gte</li>
     * <li>$btw</li></ul>
     */
      'filter.useremployments.validTo'?: Array<string>;

    /**
     * Filter by entrydate query param.
     *           <p>
     *              <b>Format: </b> filter.entrydate={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.entrydate=$not:$like:John Doe&filter.entrydate=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$lte</li>
     * <li>$gte</li>
     * <li>$btw</li>
     * <li>$null</li></ul>
     */
      'filter.entrydate'?: Array<string>;

    /**
     * Filter by exitdate query param.
     *           <p>
     *              <b>Format: </b> filter.exitdate={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.exitdate=$not:$like:John Doe&filter.exitdate=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$lte</li>
     * <li>$gte</li>
     * <li>$btw</li>
     * <li>$null</li></ul>
     */
      'filter.exitdate'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> lastName:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>lastName</li>
     * <li>birthdate</li>
     * <li>entrydate</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'lastName:ASC' | 'lastName:DESC' | 'birthdate:ASC' | 'birthdate:DESC' | 'entrydate:ASC' | 'entrydate:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> searchableFullname
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>searchableFullname</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkUserV2>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'businessunitId'?: (string | Array<string>);
'businessdivisionId'?: (string | Array<string>);
'active'?: (string | Array<string>);
'supervisorId'?: (string | Array<string>);
'id'?: (string | Array<string>);
'employmentType'?: (string | Array<string>);
'useremployments.type'?: (string | Array<string>);
'useremployments.validFrom'?: (string | Array<string>);
'useremployments.validTo'?: (string | Array<string>);
'entrydate'?: (string | Array<string>);
'exitdate'?: (string | Array<string>);
};
};
}> {
    return this.usersV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkUserV2>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'businessunitId'?: (string | Array<string>);
'businessdivisionId'?: (string | Array<string>);
'active'?: (string | Array<string>);
'supervisorId'?: (string | Array<string>);
'id'?: (string | Array<string>);
'employmentType'?: (string | Array<string>);
'useremployments.type'?: (string | Array<string>);
'useremployments.validFrom'?: (string | Array<string>);
'useremployments.validTo'?: (string | Array<string>);
'entrydate'?: (string | Array<string>);
'exitdate'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkUserV2>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'businessunitId'?: (string | Array<string>);
'businessdivisionId'?: (string | Array<string>);
'active'?: (string | Array<string>);
'supervisorId'?: (string | Array<string>);
'id'?: (string | Array<string>);
'employmentType'?: (string | Array<string>);
'useremployments.type'?: (string | Array<string>);
'useremployments.validFrom'?: (string | Array<string>);
'useremployments.validTo'?: (string | Array<string>);
'entrydate'?: (string | Array<string>);
'exitdate'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `usersV2ControllerCreate()` */
  static readonly UsersV2ControllerCreatePath = '/v2/users';

  /**
   * Required permissions: users:create, users:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersV2ControllerCreate$Response(
    params: {
      body: WorkCreateUserDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkUserV2>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUsersV2Service.UsersV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkUserV2>;
      })
    );
  }

  /**
   * Required permissions: users:create, users:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersV2ControllerCreate(
    params: {
      body: WorkCreateUserDto
    },
    context?: HttpContext
  ): Observable<WorkUserV2> {
    return this.usersV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkUserV2>): WorkUserV2 => r.body)
    );
  }

  /** Path part for operation `usersV2ControllerFindOneById()` */
  static readonly UsersV2ControllerFindOneByIdPath = '/v2/users/{id}';

  /**
   * Required permissions: users:read, users:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkUserV2>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUsersV2Service.UsersV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkUserV2>;
      })
    );
  }

  /**
   * Required permissions: users:read, users:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkUserV2> {
    return this.usersV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkUserV2>): WorkUserV2 => r.body)
    );
  }

  /** Path part for operation `usersV2ControllerUpdate()` */
  static readonly UsersV2ControllerUpdatePath = '/v2/users/{id}';

  /**
   * Required permissions: users:update, users:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateUserDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkUserV2>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUsersV2Service.UsersV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkUserV2>;
      })
    );
  }

  /**
   * Required permissions: users:update, users:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateUserDto
    },
    context?: HttpContext
  ): Observable<WorkUserV2> {
    return this.usersV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkUserV2>): WorkUserV2 => r.body)
    );
  }

  /** Path part for operation `usersV2ControllerFindTeamForUserId()` */
  static readonly UsersV2ControllerFindTeamForUserIdPath = '/v2/users/{id}/team';

  /**
   * Required permissions: users:read, users:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersV2ControllerFindTeamForUserId()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV2ControllerFindTeamForUserId$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkUserV2>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUsersV2Service.UsersV2ControllerFindTeamForUserIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkUserV2>>;
      })
    );
  }

  /**
   * Required permissions: users:read, users:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersV2ControllerFindTeamForUserId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV2ControllerFindTeamForUserId(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkUserV2>> {
    return this.usersV2ControllerFindTeamForUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkUserV2>>): Array<WorkUserV2> => r.body)
    );
  }

  /** Path part for operation `usersV2ControllerFindRoletypesById()` */
  static readonly UsersV2ControllerFindRoletypesByIdPath = '/v2/users/{id}/roletypes';

  /**
   * Required permissions: users:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersV2ControllerFindRoletypesById()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV2ControllerFindRoletypesById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkRoletype>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUsersV2Service.UsersV2ControllerFindRoletypesByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkRoletype>>;
      })
    );
  }

  /**
   * Required permissions: users:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersV2ControllerFindRoletypesById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV2ControllerFindRoletypesById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkRoletype>> {
    return this.usersV2ControllerFindRoletypesById$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkRoletype>>): Array<WorkRoletype> => r.body)
    );
  }

  /** Path part for operation `usersV2ControllerAddRoletypeToUser()` */
  static readonly UsersV2ControllerAddRoletypeToUserPath = '/v2/users/{id}/roletypes';

  /**
   * Required permissions: users:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersV2ControllerAddRoletypeToUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersV2ControllerAddRoletypeToUser$Response(
    params: {
      id: number;
      body: WorkAddRoletypeDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUsersV2Service.UsersV2ControllerAddRoletypeToUserPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: users:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersV2ControllerAddRoletypeToUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersV2ControllerAddRoletypeToUser(
    params: {
      id: number;
      body: WorkAddRoletypeDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.usersV2ControllerAddRoletypeToUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `usersV2ControllerRemoveRoletypeFromUser()` */
  static readonly UsersV2ControllerRemoveRoletypeFromUserPath = '/v2/users/{id}/roletypes';

  /**
   * Required permissions: users:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersV2ControllerRemoveRoletypeFromUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersV2ControllerRemoveRoletypeFromUser$Response(
    params: {
      id: number;
      body: WorkRemoveRoletypeDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUsersV2Service.UsersV2ControllerRemoveRoletypeFromUserPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: users:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersV2ControllerRemoveRoletypeFromUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersV2ControllerRemoveRoletypeFromUser(
    params: {
      id: number;
      body: WorkRemoveRoletypeDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.usersV2ControllerRemoveRoletypeFromUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `usersV2ControllerFindTagsById()` */
  static readonly UsersV2ControllerFindTagsByIdPath = '/v2/users/{id}/tags';

  /**
   * Required permissions: users:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersV2ControllerFindTagsById()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV2ControllerFindTagsById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTag>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUsersV2Service.UsersV2ControllerFindTagsByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTag>>;
      })
    );
  }

  /**
   * Required permissions: users:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersV2ControllerFindTagsById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV2ControllerFindTagsById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkTag>> {
    return this.usersV2ControllerFindTagsById$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTag>>): Array<WorkTag> => r.body)
    );
  }

  /** Path part for operation `usersV2ControllerAddTagToUser()` */
  static readonly UsersV2ControllerAddTagToUserPath = '/v2/users/{id}/tags/{tagId}';

  /**
   * Required permissions: news:create, news:update, news:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersV2ControllerAddTagToUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV2ControllerAddTagToUser$Response(
    params: {
      id: number;
      tagId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUsersV2Service.UsersV2ControllerAddTagToUserPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('tagId', params.tagId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: news:create, news:update, news:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersV2ControllerAddTagToUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV2ControllerAddTagToUser(
    params: {
      id: number;
      tagId: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.usersV2ControllerAddTagToUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `usersV2ControllerRemoveTagFromUser()` */
  static readonly UsersV2ControllerRemoveTagFromUserPath = '/v2/users/{id}/tags/{tagId}';

  /**
   * Required permissions: news:create, news:update, news:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersV2ControllerRemoveTagFromUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV2ControllerRemoveTagFromUser$Response(
    params: {
      id: number;
      tagId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUsersV2Service.UsersV2ControllerRemoveTagFromUserPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('tagId', params.tagId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: news:create, news:update, news:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersV2ControllerRemoveTagFromUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersV2ControllerRemoveTagFromUser(
    params: {
      id: number;
      tagId: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.usersV2ControllerRemoveTagFromUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

}
